import { Component } from '@angular/core';

@Component({
  selector: 'app-cgu-en',
  templateUrl: './cgu-en.component.html',
  styleUrls: ['./cgu-en.component.scss'],
  standalone: false,
})
export class CguEnComponent {}
